import React, { useState, useEffect } from "react";
import OfficesList from "./OfficesList";
import Error403Page from "./Error_backend";
import api from "../api.js";
import "../style/css/Offices.css";
import OfficesHoursList from "./OfficesHoursList";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";

export interface Office {
  id: string;
  professional: string;
  name: string;
  address: string;
  city: string;
  state: string;
  country: string;
  phone?: string;
  email?: string;
  website?: string;
  availability: Availability[];
}

export interface Availability {
  id: string;
  office: string;
  day_of_week: number;
  start_time: string;
  end_time: string;
  appointment_duration: number;
  break_start_time: string | null;
  break_end_time: string | null;
}

const OfficesManager: React.FC = () => {
  const [offices, setOffices] = useState<Office[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState<"offices" | "hours">("offices");
  const navigate = useNavigate();

  useEffect(() => {
    fetchOffices();
  }, []);

  const fetchOffices = async () => {
    try {
      setLoading(true);
      // Replace with your actual API endpoint
      const response = api.get(`/offices/`);
      if (!response) {
        throw new Error("Failed to fetch offices");
      }

      const data = (await response).data;
      setOffices(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  const handleAddOffice = () => {
    navigate("/office/new");
  };

  const handleEditOffice = (officeId: string) => {
    navigate(`/offices/${officeId}/edit`);
  };

  const handleDeleteOffice = (officeId: string) => {
    // Handle delete office logic
    console.log("Delete office:", officeId);
  };

  const handleToggleStatus = (officeId: string, currentStatus: boolean) => {
    // Handle toggle status logic
    console.log("Toggle status for office:", officeId, "to:", !currentStatus);
  };

  const handleEditHours = (officeId: string) => {
    navigate(`/offices/availability/${officeId}`);
  };

  if (loading) {
    return <div className="text-center">Cargando oficinas...</div>;
  }

  if (error) {
    // Renderizamos Error403Page usando las props para personalizar el error si lo detectamos
    const codeToShow = "Problemas encontrando el recurso";
    const titleToShow = "Error de Carga";
    const messageToShow = "Error al cargar las sedes";

    return (
      <Error403Page
        code={codeToShow}
        title={titleToShow}
        message={messageToShow}
      />
    );
  }

  return (
    <div className="container">
      <div className="tabs">
        <button
          className={`tab ${activeTab === "offices" ? "active" : ""}`}
          onClick={() => setActiveTab("offices")}
        >
          Oficinas
        </button>
        <button
          className={`tab ${activeTab === "hours" ? "active" : ""}`}
          onClick={() => setActiveTab("hours")}
        >
          Horarios de Oficina
        </button>
      </div>

      {activeTab === "offices" && (
        <OfficesList
          offices={offices}
          onEdit={handleEditOffice}
          onDelete={handleDeleteOffice}
          onToggleStatus={handleToggleStatus}
          onAddOffice={handleAddOffice}
        />
      )}

      {activeTab === "hours" && (
        <OfficesHoursList
          offices={offices}
          onEditHours={handleEditHours}
          onToggleStatus={handleToggleStatus}
        />
      )}
    </div>
  );
};

export default OfficesManager;
